import { JsonConverter, JsonCustomConvert } from 'json2typescript';

import { ActivityWithoutIncomeSource } from '../../../../../core';

@JsonConverter
export class ActivityWithoutIncomeSourceAdapter implements JsonCustomConvert<ActivityWithoutIncomeSource | undefined> {
    serialize(situation: ActivityWithoutIncomeSource): any | undefined {
        return situation ? String(situation) : undefined;
    }

    deserialize(situation: any): ActivityWithoutIncomeSource | undefined {
        switch (situation) {
            case '1':
                return ActivityWithoutIncomeSource.MINOR;
            case '2':
                return ActivityWithoutIncomeSource.STUDENT;
            case '3':
                return ActivityWithoutIncomeSource.UNEMPLOYEMENT_WITHOUT_BENEFIT;
            case '4':
                return ActivityWithoutIncomeSource.HOUSEWIFE;
            case '5':
                return ActivityWithoutIncomeSource.ACTIVITY_OF_COOWNER;
            case '6':
                return ActivityWithoutIncomeSource.OTHERS;
            default:
                return undefined;
        }
    }
}
